import React from 'react';
import { AlertTriangle, Info, OctagonAlert, Sparkles } from 'lucide-react';

const FLAG = {
  error: { cls: 'bg-red-50 border-red-200 text-red-900', Icon: OctagonAlert },
  warning: { cls: 'bg-amber-50 border-amber-200 text-amber-900', Icon: AlertTriangle },
  info: { cls: 'bg-gray-50 border-gray-200 text-gray-700', Icon: Info },
};

// Lane selector (commodity × destination market), completion and live regulatory flags.
export function LaneHeader({ data, onLaneChange, busy }) {
  const { lane, commodities, markets, flags, completion } = data;
  const detected = lane.detected || {};
  return (
    <div className="space-y-4" data-testid="cargo-lane-header">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="grid sm:grid-cols-2 gap-3 flex-1">
          <label className="text-sm text-gray-700">
            <span className="block text-xs uppercase tracking-[0.08em] text-gray-500 mb-1">Commodity</span>
            <select value={lane.commodity} disabled={busy} onChange={function (e) { onLaneChange({ commodity: e.target.value }); }} className="flex h-10 w-full rounded-sm border border-input bg-background px-3 text-sm" data-testid="cargo-commodity-select">
              {commodities.map(function (c) { return <option key={c.key} value={c.key}>{c.label}</option>; })}
            </select>
          </label>
          <label className="text-sm text-gray-700">
            <span className="block text-xs uppercase tracking-[0.08em] text-gray-500 mb-1">Destination market</span>
            <select value={lane.market} disabled={busy} onChange={function (e) { onLaneChange({ market: e.target.value }); }} className="flex h-10 w-full rounded-sm border border-input bg-background px-3 text-sm" data-testid="cargo-market-select">
              {markets.map(function (m) { return <option key={m.key} value={m.key}>{m.label}</option>; })}
            </select>
          </label>
        </div>
        <div className="flex items-center gap-4 lg:w-72" data-testid="cargo-completion">
          <div className="flex-1">
            <div className="flex justify-between text-xs text-gray-600 mb-1"><span>Set completion</span><span className="sv-mono" data-testid="cargo-completion-text">{completion.done}/{completion.total} · {completion.percent}%</span></div>
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden"><div className="h-full bg-ink rounded-full transition-[width] duration-500" style={{ width: completion.percent + '%' }} /></div>
          </div>
        </div>
      </div>
      <p className="text-xs text-gray-500 flex items-center gap-1.5" data-testid="cargo-lane-detected">
        <Sparkles className="h-3.5 w-3.5 text-blue-600" />
        {detected.commodity ? 'Lane detected from the booking: ' + (commodities.find(function (c) { return c.key === detected.commodity; }) || {}).label + ' → ' + (markets.find(function (m) { return m.key === detected.market; }) || {}).label : 'Commodity could not be detected from the booking — choose it above.'}
      </p>
      {flags.length > 0 && (
        <div className="grid gap-2" data-testid="cargo-flags">
          {flags.map(function (f) {
            const S = FLAG[f.severity] || FLAG.info;
            return (
              <div key={f.code} className={'flex gap-3 rounded-sm border px-3 py-2.5 text-sm ' + S.cls} data-testid={'cargo-flag-' + f.code}>
                <S.Icon className="h-4 w-4 mt-0.5 shrink-0" strokeWidth={1.75} />
                <div><p className="font-medium">{f.title}</p><p className="text-[13px] opacity-90 mt-0.5">{f.detail}</p></div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
